import HalfEdgeMesh from '@/modules/three/common/halfEdgeMesh/HalfEdgeMesh.js';
import fixRotationStore, { rotationPhase } from '@modules/fixRotation/store/fixRotationStore';
import { threeInteractionStore } from '@modules/three/store/threeInteractionStore';

export default class FixRotationService {
  private readonly upperJawMesh: HalfEdgeMesh;
  private readonly lowerJawMesh: HalfEdgeMesh;

  constructor(upperJawMesh: HalfEdgeMesh, lowerJawMesh: HalfEdgeMesh) {
    this.lowerJawMesh = lowerJawMesh;
    this.upperJawMesh = upperJawMesh;
    fixRotationStore.subscribe(
      (state) => state.rotationPhase,
      (rotationPhase) => this.changeRotationPhase(rotationPhase),
    );
  }

  private changeRotationPhase(phase: rotationPhase) {
    switch (phase) {
      case 'start':
        threeInteractionStore.getState().setPointAdding(false);
        break;
      case 'select':
        threeInteractionStore.getState().setPointAdding(true);
        this.lowerJawMesh.setAnchorInsertion(true);
        this.upperJawMesh.visible = false;
        this.upperJawMesh.raycast = () => null;
        break;
      case 'fixed':
        threeInteractionStore.getState().setPointAdding(false);
        this.upperJawMesh.visible = true;
        break;
      case 'done':
        threeInteractionStore.getState().setPointAdding(false);
        break;
      default:
        break;
    }
  }

  public fixRotation() {
    const rotation = this.lowerJawMesh.fixRotation();
    this.lowerJawMesh.setAnchorInsertion(false);
    this.upperJawMesh.setRotationFromQuaternion(rotation);
    fixRotationStore.getState().setRotationPhase('fixed');
    fixRotationStore.getState().setLowerJawMesh(this.lowerJawMesh);
    fixRotationStore.getState().setUpperJawMesh(this.upperJawMesh);
  }
}
